/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState, useCallback } from "react";
import Slider from "react-slick";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Pageheading from "../../components/PageHeading/Pageheading";
import { RiHome2Line } from "react-icons/ri";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BiRightArrowAlt } from "react-icons/bi";
import "./Category.css";
import CustomPlaybutton from "../../components/Buttons/CustomPlaybutton";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import bg from "../../assets/bg_image/banner.png";
import Page from "../../components/CatList/Page";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import Button from "../../components/Buttons/Button";
import MobileSlider from "../../components/CostomSlider/MobileSlider";
import { Allcommercials, commercials } from "../../data/CategoryData";
import YoutubeLazyLoad from "../../components/YoutubeLazyLoad";
import { useWindowSize } from "react-use";
import { tvcsVideos } from "../../data/data";
import YoutubeEmbed from "../../components/YoutubeEmbedCommercials";
import {
  Banner121,
  Banner122,
  Banner123,
} from "../../assets/TVCS_Video/Banners";
const ShortsDocumentaries = ({ pageHeading }) => {
  const { width } = useWindowSize();
  const [isHoveredIndex, setIsHoveredIndex] = useState(null);

  const divideCount = Math.ceil(tvcsVideos?.length / 8);
  const sortedVideos = [];
  for (let i = 0; i < divideCount; i++) {
    sortedVideos[i] = tvcsVideos?.slice(i * 8, 8 * (i + 1));
  }

  return (
    <div className="relative">
      <div className="px-4 md:px-[7.2vw] z-10 flex items-center pt-[25vw] md:pt-[10.29vw]">
        <Pageheading pageHeading={pageHeading} icon={<RiHome2Line />} />
      </div>
      <section className="w-full px-4 pt-6 md:px-[7.2vw] md:pt-[4.7vw]">
        {/* <h2 className="w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:sm:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
          TVCS
        </h2> */}
        <h2 className="w-full text-[11vw] md:text-[5.5vw] leading-[11vw] md:leading-[5.5vw] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
          TVCS
        </h2>

        {width > 992 ? (
          <div className="space-y-4 mt-8">
            <div className="grid grid-cols-3 gap-y-4 md:gap-4">
              {/* <div className="w-full h-full" data-aos="fade-up">
                <YoutubeEmbed
                  id={"Rg_Ov9IDR5s"}
                  videoId={"Rg_Ov9IDR5s"}
                  thumbnail={
                    "https://img.youtube.com/vi/Rg_Ov9IDR5s/hqdefault.jpg"
                  }
                  iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
                  iframecss="w-full h-full"
                  isHoveredIndex={isHoveredIndex}
                  setIsHoveredIndex={setIsHoveredIndex}
                />
              </div>
              <div className="w-full h-full" data-aos="fade-up">
                <YoutubeEmbed
                  id={"0qAWa1A7ofc"}
                  videoId={"0qAWa1A7ofc"}
                  thumbnail={
                    "https://img.youtube.com/vi/0qAWa1A7ofc/hqdefault.jpg"
                  }
                  iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
                  iframecss="w-full h-full"
                  isHoveredIndex={isHoveredIndex}
                  setIsHoveredIndex={setIsHoveredIndex}
                />
              </div>
              <div className="w-full h-full" data-aos="fade-up">
                <YoutubeEmbed
                  id={"UofYUxJxUMY"}
                  videoId={"UofYUxJxUMY"}
                  thumbnail={
                    "https://img.youtube.com/vi/UofYUxJxUMY/hqdefault.jpg"
                  }
                  iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
                  iframecss="w-full h-full"
                  isHoveredIndex={isHoveredIndex}
                  setIsHoveredIndex={setIsHoveredIndex}
                />
              </div> */}
            </div>
            {/* STATIC VIDEO GRID START */}
            <div className="grid grid-cols-2 md:gap-4 grid-rows-[225px] lg2-plus:grid-rows-[300px] xl:grid-rows-[400px] 2xl-plus:grid-rows-[555px] 3xl-plus:grid-rows-[624px] gap-4">
              <div className="w-full h-full" data-aos="fade-up">
                <YoutubeEmbed
                  id={"QNHoX7vc2Hw"}
                  videoId={"QNHoX7vc2Hw"}
                  thumbnail={Banner121}
                  iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
                  iframecss="w-full h-full"
                    imagecss="!object-fill"
                  isHoveredIndex={isHoveredIndex}
                  setIsHoveredIndex={setIsHoveredIndex}
                />
              </div>
              {/* <div className="w-full h-full col-span-2" data-aos="fade-up"> */}
              <div className="w-full h-full" data-aos="fade-up">
                <YoutubeEmbed
                  id={"G2AvGScw83M"}
                  videoId={"G2AvGScw83M"}
                  thumbnail={Banner123}
                  iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
                  iframecss="w-full h-full"
                  imagecss="!object-fill"
                  isHoveredIndex={isHoveredIndex}
                  setIsHoveredIndex={setIsHoveredIndex}
                />
              </div>
              {/* cannon duplicate video */}
              {/* <div className="w-full h-full" data-aos="fade-up">
                <YoutubeEmbed
                  id={"TSmzqwKhdMo"}
                  videoId={"TSmzqwKhdMo"}
                  thumbnail={Banner121}
                  iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
                  iframecss="w-full h-full"
                  isHoveredIndex={isHoveredIndex}
                  setIsHoveredIndex={setIsHoveredIndex}
                />
              </div> */}
            </div>
            {/* STATIC VIDEO GRID END */}

            {sortedVideos?.map((videoList, i) => {
              const leftVideos = videoList
                ?.slice(0, 8)
                ?.filter((_, i) => i % 3 === 0);

              const rightVideos = videoList
                ?.slice(0, 8)
                ?.filter((_, i) => i % 3 !== 0);

              const leftGridSetting =
                leftVideos.length === 3
                  ? "grid-rows-[225px,150px,225px] lg2-plus:grid-rows-[300px,170px,300px] xl:grid-rows-[400px,200px,400px] 2xl-plus:grid-rows-[554px,348px,555px]  3xl-plus:grid-rows-[623px,391px,624px]"
                  : leftVideos.length === 2
                    ? "grid-rows-[225px,150px] lg2-plus:grid-rows-[300px,170px] xl:grid-rows-[400px,200px] 2xl-plus:grid-rows-[554px,348px] 3xl-plus:grid-rows-[623px,391px]"
                    : "grid-rows-[225px] lg2-plus:grid-rows-[300px] xl:grid-rows-[400px] 2xl-plus:grid-rows-[555px] 3xl-plus:grid-rows-[623px]";

              const rightGridSetting =
                rightVideos.length >= 5
                  ? "grid-rows-[187.5px,187.5px,225px] lg2-plus:grid-rows-[235px,235px,300px] xl:grid-rows-[290px,310px,400px] 2xl-plus:grid-rows-[450px,450px,555px] 3xl-plus:grid-rows-[506px,506px,624px]"
                  : rightVideos.length >= 3
                    ? "grid-rows-[187.5px,187.5px] lg2-plus:grid-rows-[235px,235px] xl:grid-rows-[290px,310px] 2xl-plus:grid-rows-[450px,450px] 3xl-plus:grid-rows-[506px,506px]"
                    : "grid-rows-[187.5px] lg2-plus:grid-rows-[235px] xl:grid-rows-[290px] 2xl-plus:grid-rows-[450px] 3xl-plus:grid-rows-[506px]";

              return (
                <div
                  className="grid grid-cols-1 md:grid-cols-3 gap-y-4 md:gap-4"
                  key={`video-list-${i}`}
                >
                  <div className={`grid ${leftGridSetting} gap-4`}>
                    {leftVideos?.map((video, k) => (
                      <div
                        className="w-full h-full"
                        key={`yt-video-${i}-${k}`}
                        data-aos="fade-up"
                      >
                        <YoutubeEmbed
                          id={video.id}
                          videoId={video.videoId}
                          thumbnail={video.thumbnail}
                          iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
                          iframecss="w-full h-full"
                          isHoveredIndex={isHoveredIndex}
                          setIsHoveredIndex={setIsHoveredIndex}
                        />
                      </div>
                    ))}
                  </div>
                  <div
                    className={`col-span-2 grid grid-cols-2 ${rightGridSetting} gap-4`}
                  >
                    {rightVideos?.map((video, j) => (
                      <div
                        className={`w-full h-full ${
                          j === 4 ? "col-span-full" : ""
                        }`}
                        key={`yt-video-${i}-${j}`}
                        data-aos="fade-up"
                      >
                        <YoutubeEmbed
                          id={video.id}
                          videoId={video.videoId}
                          thumbnail={video.thumbnail}
                          iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
                          iframecss="w-full h-full"
                          imagecss={i === 1 && j === 0 ? "!object-center" : ""}
                          isHoveredIndex={isHoveredIndex}
                          setIsHoveredIndex={setIsHoveredIndex}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-4 mt-8">
            {/* <div className="w-full h-full aspect-[16/11]" data-aos="fade-up">
              <YoutubeEmbed
                videoId={"Rg_Ov9IDR5s"}
                thumbnail={
                  "https://img.youtube.com/vi/Rg_Ov9IDR5s/hqdefault.jpg"
                }
                iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px]"
                iframecss="w-full h-full"
              />
            </div>
            <div className="w-full h-full aspect-[16/11]" data-aos="fade-up">
              <YoutubeEmbed
                videoId={"0qAWa1A7ofc"}
                thumbnail={
                  "https://img.youtube.com/vi/0qAWa1A7ofc/hqdefault.jpg"
                }
                iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px]"
                iframecss="w-full h-full"
              />
            </div>
            <div className="w-full h-full aspect-[16/11]" data-aos="fade-up">
              <YoutubeEmbed
                videoId={"UofYUxJxUMY"}
                thumbnail={
                  "https://img.youtube.com/vi/UofYUxJxUMY/hqdefault.jpg"
                }
                iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px]"
                iframecss="w-full h-full"
              />
            </div> */}

            <div className="w-full h-full aspect-[16/11]" data-aos="fade-up">
              <YoutubeEmbed
                videoId={"QNHoX7vc2Hw"}
                thumbnail={Banner121}
                iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px]"
                  imagecss="!object-fill"
                iframecss="w-full h-full"
              />
            </div>
            <div className="w-full h-full aspect-[16/11]" data-aos="fade-up">
              <YoutubeEmbed
                videoId={"G2AvGScw83M"}
                thumbnail={Banner123}
                iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px]"
                iframecss="w-full h-full"
                imagecss="!object-fill"
              />
            </div>
               {/* cannon duplicate video */}
            {/* <div className="w-full h-full aspect-[16/11]" data-aos="fade-up">
              <YoutubeEmbed
                videoId={"TSmzqwKhdMo"}
                thumbnail={Banner121}
                iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px]"
                iframecss="w-full h-full"
              />
            </div> */}

            {tvcsVideos?.map((video, i) => (
              <div
                className="w-full h-full aspect-[16/11]"
                key={`yt-video-${i}`}
                data-aos="fade-up"
              >
                <YoutubeEmbed
                  videoId={video.videoId}
                  thumbnail={video.thumbnail}
                  iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px]"
                  iframecss="w-full h-full"
                />
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default ShortsDocumentaries;
